import React, { createContext, useState } from "react";

export const LettersContext = createContext();
export const LettersDispatch = createContext();

export const LettersProvider = ({ children }) => {
    const [lettersArray, setLettersArray] = useState([]);

    return (
        <LettersContext.Provider value={lettersArray}>
            <LettersDispatch.Provider value={setLettersArray}>
                {children}
            </LettersDispatch.Provider>
        </LettersContext.Provider>
    );
};

